export enum ReturnsSortingMode {
  SERVICE_LEVEL = "service_level",
  PRIORITY = "priority",
}

export const returnsSortingMode = Object.values(ReturnsSortingMode);

export enum RedoManagedReturnsSortingMode {
  DEFAULT = "default",
  HIGH_PRIORITY = "high_priority",
}

export const redoManagedReturnsSortingMode = Object.values(
  RedoManagedReturnsSortingMode,
);

export const defaultReturnsSortingMode = ReturnsSortingMode.SERVICE_LEVEL;
export const defaultRedoManagedReturnsSortingMode =
  RedoManagedReturnsSortingMode.DEFAULT;

export function isReturnsSortingMode(
  value: string | null | undefined,
): value is ReturnsSortingMode {
  return returnsSortingMode.includes(value as ReturnsSortingMode);
}

export function isRedoManagedReturnsSortingMode(
  value: string | null | undefined,
): value is RedoManagedReturnsSortingMode {
  return redoManagedReturnsSortingMode.includes(
    value as RedoManagedReturnsSortingMode,
  );
}
